const columns = [{
    title: 'Nome',
    searchName: "nome",
    dataIndex: 'name',
    key: 'name',
    width: '35%',
    sortKind: "string"
}, {
    title: 'CPF',
    searchName: "CPF",
    dataIndex: 'document',
    key: 'document',
    width: '25%',
    sortKind: "string"
},{
    title: 'Email',
    searchName: "email",
    dataIndex: 'email',
    key: 'email',
    width: '25%',
    sortKind: "string"
},{
    title: 'Ação',
    dataIndex: 'uf',
    key: 'action',
    width: '15%'
}];

export default columns;


// WEBPACK FOOTER //
// ./src/const/columns/client.js